module.exports = __webpack_public_path__ + "static/3-53aa06cf17e4239d0dba6ffd09854e02.png";